"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card2D = Card2D;
const react_1 = __importStar(require("react"));
const ui_1 = require("@creature-chess/ui");
const CoinIcon_1 = require("~/components/ui/icon/CoinIcon");
const useStyles_1 = require("~/useStyles");
const TraitIcon_1 = require("../../../ui/TraitIcon");
const creatureImage_1 = require("../../../ui/creatureImage");
const useStyles = (0, useStyles_1.createUseThemeStyles)((theme) => ({
    card: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        userSelect: "none",
        containerType: "inline-size",
        containerName: "card",
        background: (props) => ["", "#696969", "#2e762e", "#2e89ff", "#931093", "#e09429"][props.card.cost] || "#ff0000",
    },
    imageContainer: {
        aspectRatio: "1/1",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
    },
    image: {
        "width": "64px",
        "height": "64px",
        "zIndex": 10,
        "position": "relative",
        "@media (orientation: portrait) and (max-width: 375px)": {
            width: "48px",
            height: "48px",
        },
    },
    shadow: {
        "position": "absolute",
        "width": (props) => ["0px", "10px", "24px", "36px", "52px", "62px"][props.card.cost] ||
            "0px",
        "height": (props) => ["0px", "10px", "24px", "36px", "52px", "62px"][props.card.cost] ||
            "0px",
        "@media (orientation: portrait) and (max-width: 375px)": {
            width: (props) => ["0px", "6px", "10px", "20px", "36px", "46px"][props.card.cost] ||
                "0px",
            height: (props) => ["0px", "6px", "10px", "20px", "36px", "46px"][props.card.cost] ||
                "0px",
        },
        "aspectRatio": "1/1",
        "background": "radial-gradient(hsl(0 0% 60% / 1), hsl(0 0% 20% / 1), hsl(0 0% 12% / 1))",
        "borderRadius": "50%",
        "filter": (props) => `blur(${["0px", "12px", "8px", "4px", "2px", "0px"][props.card.cost] || "0px"})`,
        "zIndex": 9,
    },
    info: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
    },
    nameBar: {
        "display": "flex",
        "justifyContent": "space-between",
        "alignItems": "center",
        "padding": "2px 8px",
        "@container card (min-height: 112px)": {
            padding: "4px 8px",
            borderBottomWidth: "6px",
        },
        "background": "#101010",
        "zIndex": 11,
        "borderBottom": (props) => `4px solid ${["", "#b4b4b4", "#4eba4e", "#0258d9", "#c94fbd", "#b86d05"][props.card.cost] || "#ff0000"}`,
    },
    name: {
        color: "#fff",
        fontFamily: theme.typography.accent,
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: "24px",
    },
    traits: {
        "display": "flex",
        "flexDirection": "row",
        "alignItems": "center",
        "height": "64px",
        "paddingBottom": "8px",
        "@container card (min-height: 112px)": {
            height: "64px",
        },
        "@media (orientation: portrait) and (max-width: 374px)": {
            height: "32px",
            paddingBottom: 0,
        },
        "@media (orientation: portrait) and (min-width: 375px) and (max-width: 429px)": {
            height: "48px",
        },
        "@media (orientation: portrait) and (min-width: 430px)": {
            height: "64px",
        },
    },
    traitIcon: {
        "height": "70%",
        "&:not(:last-child)": {
            marginRight: "16px",
        },
        "@media (max-width: 375px)": {
            "&:not(:last-child)": {
                marginRight: "8px",
            },
        },
    },
    buyContainer: {
        background: "#101010",
        width: "20%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    buy: {
        "border": "none",
        "height": "75%",
        "width": "75%",
        "cursor": "pointer",
        "background": "#38b764",
        "color": "#101010",
        "borderRadius": "12.5%",
        "fontFamily": theme.typography.primary,
        "fontOpticalSizing": "auto",
        "fontWeight": 700,
        "fontStyle": "normal",
        "fontSize": "18px",
        "letterSpacing": "-1px",
        "&[disabled]": {
            background: "#303030",
            cursor: "not-allowed",
        },
        "&:hover": {
            background: "#4aeb82",
        },
        "transition": "background 0.2s ease-in-out",
    },
    ownedIcon: {
        width: "24px",
        height: "24px",
    },
}));
function Card2D(props) {
    const classes = useStyles(props);
    const { card, money } = props;
    const [shuffleAmount, setShuffleAmount] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        if (card) {
            const multiplier = card.cost * 4;
            const amount = Math.random() * multiplier - multiplier / 2;
            setShuffleAmount(amount);
        }
    }, [card]);
    const onBuy = (0, react_1.useCallback)(() => {
        if (!props.onBuy || !card || card.cost > money) {
            return;
        }
        props.onBuy();
    }, [props, card, money]);
    if (!card) {
        return null;
    }
    return (react_1.default.createElement("div", { className: classes.card },
        react_1.default.createElement("div", { className: classes.imageContainer },
            react_1.default.createElement("div", { className: classes.shadow }),
            react_1.default.createElement(creatureImage_1.CreatureImage, { definitionId: card.definitionId, className: classes.image })),
        react_1.default.createElement("div", { className: classes.info },
            react_1.default.createElement("div", { className: classes.nameBar },
                react_1.default.createElement("span", { className: classes.name }, card.name),
                props.owned && (react_1.default.createElement("img", { className: classes.ownedIcon, src: `${APP_IMAGE_ROOT}/ui/arrow_up_green.png` }))),
            react_1.default.createElement("div", { className: classes.traits }, card.traits.map((trait) => (react_1.default.createElement(TraitIcon_1.TraitIcon, { key: trait, className: classes.traitIcon, trait: trait, label: true }))))),
        react_1.default.createElement("div", { className: classes.buyContainer },
            react_1.default.createElement(ui_1.Button, { disabled: card.cost > money, onClick: onBuy, color: "secondary", size: "medium" },
                react_1.default.createElement("div", { style: { rotate: `${shuffleAmount}deg` } },
                    card.cost,
                    " ",
                    react_1.default.createElement(CoinIcon_1.CoinIcon, null))))));
}
